import React from "react";
import { Routes, Route } from 'react-router-dom';

import PublisherDashboard from './../Pages/Publisher/Dashboard';

import PublisherLeads from './../Pages/Publisher/Leads/Lead';
import PublisherLeadFilter from './../Pages/Publisher/Leads/LeadFilter';

import PublisherLeadEdit from './../Pages/Publisher/Leads/EditLead';

import PublisherLeadAdd from './../Pages/Publisher/LeadAdd';

import PublisherNotifications from './../Pages/Publisher/Notification';

import PublisherProfile from './../Pages/Publisher/Profile';

//import PublisherProfile from './../Pages/Publisher/Profile';

//import NotFound from './../Pages/NotFound';

const Publisher = [
    {
        path: "publisher/dashboard", 
        element: <PublisherDashboard />,
    },
    {
        path: "publisher/leads", 
        element: <PublisherLeads />,
    },
    {
        path: "publisher/lead/:filtertype", 
        element: <PublisherLeadFilter />,
    },
    {
        path: "publisher/lead-profile/:leadid", 
        element: <PublisherLeadEdit />,
    },
    {
        path: "publisher/lead/add",
        element: <PublisherLeadAdd />,
    },
    {
        path: "publisher/notifications", 
        element: <PublisherNotifications />,
    },
    {
        path: "publisher/edit-profile", 
        element: <PublisherProfile />,
    }
];



export default Publisher;